import React, { useCallback, useState } from "react";
import { useChannelEventListener } from "@activecollab/activecollab-react-pusher";
import PropTypes from "prop-types";
import { WhoIsOnlineContextProvider } from "./context/index.jsx";

export const WhoIsOnline = ({ children }) => {
  const [members, setMembers] = useState([]);

  const handleSubscriptionSucceded = useCallback((members) => {
    setMembers(() => {
      const result = [];
      members.each((member) => {
        result.push(parseInt(member.id));
      });
      return result;
    });
  }, []);

  const handleMemberAdded = useCallback((member) => {
    setMembers((prevState) => [...prevState, parseInt(member.id)]);
  }, []);

  const handleMemberRemoved = useCallback((member) => {
    const id = parseInt(member.id);
    setMembers((prevState) => prevState.filter((userId) => userId !== id));
  }, []);

  useChannelEventListener("pusher:subscription_succeeded", handleSubscriptionSucceded);
  useChannelEventListener("pusher:member_added", handleMemberAdded);
  useChannelEventListener("pusher:member_removed", handleMemberRemoved);

  return <WhoIsOnlineContextProvider value={{ members }}>{children}</WhoIsOnlineContextProvider>;
};

WhoIsOnline.propTypes = {
  children: PropTypes.any,
};
